module.exports = __webpack_public_path__ + "img/logo-icon.de1f40a6.png";